export const InvitationEndpoints = {
  list: '/invitation/list',
  export: '/invitation/export',
  find: (id: string) => `/invitation/${id}`,
  add: '/invitation/add',
  resend: (id: string) => `/invitation/resend/${id}`,
  cancel: (id: string) => `/invitation/cancel/${id}`,
  delete: (id: string) => `/invitation/del/${id}`,
  validate: (inviteId: string) => `/public/invitations/${inviteId}`,
  accept: (inviteId: string) => `/public/invitations/accept/${inviteId}`,
};
